<template>
  <v-layout row>
    <v-flex xs6>
      <v-layout row>
        <v-flex xs12 class="centerText">
          <span class="caption">{{ labels.contactInformationTitle }}</span>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs2>
          <v-text-field :label="labels.contactSalutationLabel"
                        v-model.trim="value.salutationCode"
                        name="salutation"
                        autocomplete="honorific-prefix"
                        :readonly="readonly"/>
        </v-flex>
        <v-flex xs5 class="ml-2">
          <v-text-field :label="labels.contactFirstNameLabel"
                        v-model.trim="value.firstName"
                        maxLength="20"
                        validate-on-blur
                        class="required-field"
                        autocomplete="given-name"
                        name="firstName"
                        :readonly="readonly"
                        :rules="[rules.required]"/>
        </v-flex>
        <v-flex xs5 class="ml-2">
          <v-text-field :label="labels.contactLastNameLabel"
                        v-model.trim="value.lastName"
                        maxLength="50"
                        validate-on-blur
                        class="required-field"
                        autocomplete="family-name"
                        name="lastName"
                        :readonly="readonly"
                        :rules="[rules.required]"/>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <v-text-field :label="labels.contactPhoneLabel"
                        v-model.trim="value.phoneNumber"
                        maxLength="20"
                        class="required-field"
                        autocomplete="tel"
                        name="phoneNumber"
                        placeholder="+33112345678"
                        :readonly="readonly"
                        validate-on-blur :rules="[rules.required, rules.phoneWithPrefix]"/>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <v-text-field :label="labels.contactMobilePhoneLabel"
                        v-model.trim="value.mobilePhoneNumber"
                        maxLength="20"
                        autocomplete="tel"
                        name="mobilePhoneNumber"
                        placeholder="+33612345678"
                        :readonly="readonly"
                        validate-on-blur :rules="[rules.phoneWithPrefix]"/>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <v-text-field :label="labels.contactFaxLabel"
                        v-model.trim="value.faxNumber"
                        autocomplete="tel"
                        name="faxNumber"
                        :readonly="readonly"
                        maxLength="20"/>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <v-text-field :label="labels.contactBusinessEmailLabel"
                        v-model.trim="value.businessEmail"
                        class="required-field"
                        maxLength="100"
                        validate-on-blur
                        autocomplete="email"
                        name="email"
                        :readonly="readonly"
                        :rules="[rules.required, rules.email]"/>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <v-text-field :label="labels.contactJobTitle"
                        v-model.trim="value.title"
                        autocomplete="organization-title"
                        name="organizationTitle"
                        :readonly="readonly"
                        maxLength="50"/>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs6 class="ml-2 pl-2" style="border-left: 1px gray dashed">
      <v-layout row>
        <v-flex xs12 class="centerText">
          <span class="caption">{{ labels.addressInformationTitle }}</span>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <v-text-field :label="labels.contactAddressLine1Label"
                        v-model.trim="value.contactAddress.addressLine1"
                        :readonly="readonly"
                        autocomplete="address-line1"
                        name="address-line-1"
                        maxLength="135"/>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <v-text-field :label="labels.contactAddressLine2Label"
                        v-model.trim="value.contactAddress.addressLine2"
                        :readonly="readonly"
                        autocomplete="address-line2"
                        name="address-line-2"
                        maxLength="105"/>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <v-text-field :label="labels.contactAddressTownLabel"
                        v-model.trim="value.contactAddress.town"
                        autocomplete="home city"
                        name="city"
                        :readonly="readonly"
                        maxLength="105"/>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs4>
          <v-text-field :label="labels.contactAddressSubdivisionLabel"
                        v-model.trim="value.contactAddress.subdivisionCode"
                        :readonly="readonly"
                        maxLength="25"/>
        </v-flex>
        <v-flex xs4 class="ml-2">
          <v-text-field :label="labels.contactAddressPostalCodeLabel"
                        v-model.trim="value.contactAddress.postalCode"
                        autocomplete="postal-code"
                        name="postalCode"
                        :readonly="readonly"
                        maxLength="27"/>
        </v-flex>
        <v-flex xs4 class="ml-2">
          <v-text-field :label="labels.contactAddressCountryCodeLabel"
                        v-model.trim="value.contactAddress.countryCode"
                        autocomplete="country"
                        name="countryCode"
                        :readonly="readonly"
                        maxLength="2"/>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>

export default {
  name: 'BuyerClaimContactInfoCard',
  props: {
    value: Object,
    formIsValid: Boolean,
    readonly: Boolean
  },
  data () {
    return {
      labels: {
        contactInformationTitle: this.$t('BuyerClaims.BuyerClaimsDetails.CONTACT_INFORMATION_TITLE'),
        addressInformationTitle: this.$t('BuyerClaims.BuyerClaimsDetails.ADDRESS_INFORMATION_TITLE'),
        yesBtnLabel: this.$t('BuyerClaims.BuyerClaimsDetails.YES_BTN'),
        noBtnLabel: this.$t('BuyerClaims.BuyerClaimsDetails.NO_BTN'),
        contactSalutationLabel: this.$t('BuyerClaims.BuyerClaimsDetails.CONTACT_SALUTATION_FIELD_NAME'),
        contactFirstNameLabel: this.$t('BuyerClaims.BuyerClaimsDetails.CONTACT_FIRST_NAME_FIELD_NAME'),
        contactLastNameLabel: this.$t('BuyerClaims.BuyerClaimsDetails.CONTACT_LAST_NAME_FIELD_NAME'),
        contactPhoneLabel: this.$t('BuyerClaims.BuyerClaimsDetails.CONTACT_PHONE_FIELD_NAME'),
        contactMobilePhoneLabel: this.$t('BuyerClaims.BuyerClaimsDetails.CONTACT_MOBILE_PHONE_FIELD_NAME'),
        contactFaxLabel: this.$t('BuyerClaims.BuyerClaimsDetails.CONTACT_FAX_FIELD_NAME'),
        contactBusinessEmailLabel: this.$t('BuyerClaims.BuyerClaimsDetails.CONTACT_BUSINESS_EMAIL_FIELD_NAME'),
        contactJobTitle: this.$t('BuyerClaims.BuyerClaimsDetails.CONTACT_JOB_TITLE_FIELD_NAME'),
        contactAddressLine1Label: this.$t('BuyerClaims.BuyerClaimsDetails.CONTACT_ADDRESS_LINE_1_FIELD_NAME'),
        contactAddressLine2Label: this.$t('BuyerClaims.BuyerClaimsDetails.CONTACT_ADDRESS_LINE_2_FIELD_NAME'),
        contactAddressTownLabel: this.$t('BuyerClaims.BuyerClaimsDetails.CONTACT_ADDRESS_TOWN_FIELD_NAME'),
        contactAddressSubdivisionLabel: this.$t('BuyerClaims.BuyerClaimsDetails.CONTACT_ADDRESS_SUBDIVISION_FIELD_NAME'),
        contactAddressPostalCodeLabel: this.$t('BuyerClaims.BuyerClaimsDetails.CONTACT_ADDRESS_POSTALCODE_FIELD_NAME'),
        contactAddressCountryCodeLabel: this.$t('BuyerClaims.BuyerClaimsDetails.CONTACT_ADDRESS_COUNTRYCODE_FIELD_NAME')
      },
      rules: {
        required: value => !!value || this.$t('BuyerClaims.BuyerClaimsDetails.REQUIRED_VALIDATION_LABEL'),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || this.$t('BuyerClaims.BuyerClaimsDetails.INVALID_EMAIL_FORMAT_VALIDATION_LABEL')
        },
        phoneWithPrefix: value => {
          const pattern = /^\+([1-9]\d{0,2})(\d{8,12})$/
          return !value || pattern.test(value) || this.$t('BuyerClaims.BuyerClaimsDetails.INVALID_PHONE_WITH_PREFIX_FORMAT_VALIDATION_LABEL')
        }
      }
    }
  },
  methods: { }
}
</script>

<style scoped>

>>> .required-field label::after {
  content: " *";
  color: red;
}
</style>
